<template>
  <div id="app">
    <Mhead v-if="isPc"></Mhead>
    <keep-alive>
      <router-view :pc="isPc" />
    </keep-alive>
  </div>
</template>

<script>
import { getData } from "@/proxy/index";
export default {
  components: {
    Mhead: () => import("@/components/head"),
  },
  data() {
    return {};
  },
  created() {
    setTimeout(() => {
      getData(this.$i18n.locale).then((res) => {
        if (res.code == 0) {
          this.$store.dispatch("setMyData", res.data.clientInfo);
        }
      });
    }, 1000);
    if (window.localStorage.getItem("GAMElang")) {
      this.$i18n.locale = window.localStorage.getItem("GAMElang");
    }
  },
  computed: {
    isPc() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      );
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/public.scss";
body a {
  -webkit-tap-highlight-color: transparent;
  text-decoration: none;
}

html,
body {
  width: 100%;
  height: 100%;
  font-family: "\5FAE\8F6F\96C5\9ED1";
  overflow-x: hidden;
  margin: 0;
  position: relative;
  -webkit-text-size-adjust: 100%;
}
span {
  outline: none;
}
.removeClickBg {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
#app {
  background: #010d35;
}
@keyframes enter-fadeup {
  0% {
    transform: translate3d(0, 72%, 0);
    opacity: 0;
  }

  to {
    transform: translateZ(0);
    opacity: 1;
  }
}

@keyframes enter-left {
  0% {
    transform: translate3d(-500%, 0, 0);
    opacity: 0;
  }

  to {
    // transform: translateZ(0);
    opacity: 1;
  }
}

@keyframes enter-right {
  0% {
    transform: translate3d(500%, 0, 0);
    opacity: 0;
  }

  to {
    // transform: translateZ(0);
    opacity: 1;
  }
}
</style>

